import React from 'react'
import componentStyles from './EmptySidePanel.module.scss'
import Icon, { IconType } from '../Icon'

export default ({ icon, title, text }) => {
  const iconStyle= {
    height: '3em',
    width: '3em'
  }

  return (
    <div className={componentStyles['empty-sidepanel']}>
      <Icon style={iconStyle} name={icon} colour={IconType.colour.londonGrey}/>
      <h1>{title}</h1>
      <div className={componentStyles['main-text']}>{text}</div>
    </div>
  )

}
